import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'gaweb-running-dog-modal',
    template: `
    <div bsModal #childModal="bs-modal" [config]="config" class="modal fade" role="dialog">
        <div class="modal-backdrop"></div>
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title pull-left">{{('RunningDogMessage' | translate) | async }}</h4>
                </div>
                <div class="modal-body">
                    <div class="trip-fetching ng-scope">
                        <p>&nbsp;</p>
                        <div class="loading-animation">
                            <div class="loading-animation__wrapper">
                                <img src="/Assets/images/layer1.png" alt="" class="loading-animation__layer loading-animation__bg1">
                                <img src="/Assets/images/layer2.png" alt="" class="loading-animation__layer loading-animation__bg2">
                                <img src="/Assets/images/layer3.png" alt="" class="loading-animation__layer loading-animation__bg3">
                                <img src="/Assets/images/layer4.png" alt="" class="loading-animation__layer loading-animation__bg4">
                                <img src="/Assets/images/layer5.png" alt="" class="loading-animation__layer loading-animation__bg5">
                                <div class="loading-animation__dog"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  `
})
export class RunningDogModalComponent implements OnInit {

    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: true
    };

    @ViewChild('childModal') public childModal: ModalDirective;

    constructor() { }

    ngOnInit() {
    }

    public showModal() {
        this.childModal.show();
    }

    public hideModal() {
        this.childModal.hide();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/running-dog-modal/running-dog-modal.component.ts